import Container from "shared/ui/container";
import CheckoutProgressBar from "widgets/checkout/progress-bar";
import CheckoutTabsProvider from "./providers/CheckoutTabsProvider";
import CurrentCheckoutTab from "./tabs";
import CheckoutMobileSteps from "widgets/checkout/mobile-steps";

const Checkout = () => {
  return (
    <CheckoutTabsProvider>
      <main className="gg-hidden sm:gg-block">
        <CheckoutProgressBar />
        <Container>
          <CurrentCheckoutTab />
        </Container>
      </main>

      <main className="sm:gg-hidden">
        <Container>
          <CheckoutMobileSteps />
        </Container>
      </main>
    </CheckoutTabsProvider>
  );
};
export default Checkout;
